import styled from "styled-components";
import colors from "../../../../styles/colors";

export const CustomImage = styled.img<{ showAlignmentButtons: boolean }>`
  border: solid 0.25rem ${props => (props.showAlignmentButtons ? colors.blue : "transparent")};
  border-radius: 1rem;
  padding: ${props => (props.showAlignmentButtons ? "0.25rem" : "0px")};
  &: hover {
    cursor: pointer;
  }
`;
